import React, { useState, useEffect } from "react";
import "../style.css";

const LiveComments = ({ postId }) => {
  const [comments, setComments] = useState([]); // List of comments
  const [newComment, setNewComment] = useState(""); // New comment text
  const [userName, setUserName] = useState(""); // User name
  const [replyTo, setReplyTo] = useState(null); // ID of the comment being replied to
  const [replyToUserName, setReplyToUserName] = useState(""); // Name of the user being replied to
  const [likedComments, setLikedComments] = useState(() => {
    return JSON.parse(localStorage.getItem("likedComments")) || [];
  });

  // Fetch comments when component loads
  useEffect(() => {
    fetch(`https://xebrand.in/Backend/get_comments.php?post_id=${postId}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setComments(data.comments);
        }
      });
  }, [postId]);

  // Submit a new comment
  const handleCommentSubmit = () => {
    if (!userName || !newComment.trim()) {
      alert("Please enter your name and comment.");
      return;
    }
  
    const avatar = `https://ui-avatars.com/api/?name=${userName}`;
    fetch("https://xebrand.in/Backend/add_comment.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        post_id: postId,
        parent_id: replyTo,
        user_name: userName,
        comment_text: newComment,
        avatar_url: avatar,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setComments((prevComments) => [
            ...prevComments,
            {
              id: Math.random(), // Temporary ID until server assigns one
              post_id: postId,
              parent_id: replyTo,
              user_name: userName,
              comment_text: newComment,
              avatar_url: avatar,
              created_at: new Date().toISOString(),
              likes: 0,
            },
          ]);
          // Clear only the comment-related fields
          setNewComment(""); // Clear the comment text
          setReplyTo(null); // Clear reply context
          setReplyToUserName(""); // Clear reply-to username
          setUserName("");
          // Keep the title and username intact
        }
      });
  };
  
  // Handle likes
  const handleLike = (id) => {
    if (!likedComments.includes(id)) {
      // Add to local storage
      const updatedLikedComments = [...likedComments, id];
      setLikedComments(updatedLikedComments);
      localStorage.setItem(
        "likedComments",
        JSON.stringify(updatedLikedComments)
      );
  
      // Update the database
      fetch("https://xebrand.in/Backend/update_comment_like.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ comment_id: id }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            // Update the UI to reflect the new like count
            setComments((prevComments) =>
              prevComments.map((comment) =>
                comment.id === id
                  ? { ...comment, likes: comment.likes + 1 }
                  : comment
              )
            );
          }
        })
        .catch((error) => console.error("Error updating like:", error));
    }
  };
  

  // Render comments with replies properly nested but respecting "root-first" logic
  const renderComments = (parentId = null, topLevelParentId = null) => {
    return comments
      .filter((comment) =>
        parentId === null ? comment.parent_id === null : comment.parent_id === parentId
      )
      .map((comment) => (
        <React.Fragment key={comment.id}>
          <div
            className="comment"
            style={{
              marginLeft: `${comment.parent_id ? 20 : 0}px`,
              borderLeft: comment.parent_id ? "2px solid #ddd" : "none",
              paddingLeft: "10px",
            }}
          >
            <div className="comment-header">
              <img
                src={comment.avatar_url}
                alt={comment.user_name}
                className="avatar"
              />
              <span className="user-name">{comment.user_name}</span>
              <span className="created-at">
                {new Date(comment.created_at).toLocaleString()}
              </span>
            </div>
            <p className="comment-text">{comment.comment_text}</p>
            <div className="comment-actions">
           
<div className="reply-like-text-cont">
<button
                onClick={() => {
                  setReplyTo(comment.id);
                  setReplyToUserName(comment.user_name);
                }}
              >
                Reply
              </button>
              <span className="like-and-liked-text">
              {likedComments.includes(comment.id) ? "Liked" : "Like"}
              </span>
</div>
              

              <span className="view-counts">
              <button onClick={() => handleLike(comment.id)}>
                 {likedComments.includes(comment.id) ? "❤️" : "♡"} 
              </button>
              <span className="like-count-text">
              {comment.likes}
        </span>

              </span>
            </div>
          </div>
          {/* Render replies to the current comment */}
          {renderComments(comment.id, topLevelParentId || comment.id)}
        </React.Fragment>
      ));
  };
  

  return (
    <div className="comments-section">
      <h3>Comments</h3>
      <div className="comment-list">{renderComments()}</div>
      <div className="comment-form">
  {replyTo && (
    <div className="replying-to">
        <span className="reply-cont">Replying to <strong>{replyToUserName}</strong>{" "}</span>
      
      <a
        onClick={() => {
          setReplyTo(null);
          setReplyToUserName("");
        }}
      >
        Cancel
      </a>
    </div>
  )}
  <input
    type="text"
    placeholder="Your Name"
    value={userName}
    onChange={(e) => setUserName(e.target.value)}
  />
  <div className="post-comment-cont">
  <textarea
    placeholder={`${
      replyTo ? `Replying to ${replyToUserName}` : "Add a comment..."
    }`}
    value={newComment}
    onChange={(e) => setNewComment(e.target.value)}
  ></textarea>
  <a onClick={handleCommentSubmit}>Post</a>
  </div>

</div>

    </div>
  );
};

export default LiveComments;
